export default __webpack_public_path__ + "static/media/avatar4.8545aa39.svg";